/* Auto background removal for uploaded payment logos (img[data-autobg]).
   Removes a solid/white background by flood-filling from the edges, feathers the edge,
   then trims empty space. If the browser blocks canvas access, CSS multiply-blend is the fallback. */
(function () {
  'use strict';
  var T1 = 38, T2 = 95;
  function dist(d, i, bg) {
    var dr = d[i] - bg[0], dg = d[i + 1] - bg[1], db = d[i + 2] - bg[2];
    return Math.sqrt(dr * dr + dg * dg + db * db);
  }
  function cut(img) {
    if (img.dataset.cut) return;
    var w0 = img.naturalWidth, h0 = img.naturalHeight;
    if (!w0 || !h0) return;
    img.dataset.cut = '1';
    try {
      var sc = Math.min(1, 320 / Math.max(w0, h0));
      var w = Math.max(1, Math.round(w0 * sc)), h = Math.max(1, Math.round(h0 * sc));
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0, w, h);
      var im = x.getImageData(0, 0, w, h), d = im.data;
      var corners = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + (w - 1)) * 4];
      var opaque = corners.filter(function (i) { return d[i + 3] > 200; });
      if (opaque.length >= 3) {
        var bg = [0, 0, 0];
        opaque.forEach(function (i) { bg[0] += d[i]; bg[1] += d[i + 1]; bg[2] += d[i + 2]; });
        bg = bg.map(function (v) { return v / opaque.length; });
        var agree = opaque.every(function (i) { return dist(d, i, bg) < 45; });
        if (agree) {
          var seen = new Uint8Array(w * h), stack = [], px, p;
          function push(a, b) { if (a < 0 || b < 0 || a >= w || b >= h) return; p = b * w + a; if (!seen[p]) { seen[p] = 1; stack.push(p); } }
          for (var i = 0; i < w; i++) { push(i, 0); push(i, h - 1); }
          for (var j = 0; j < h; j++) { push(0, j); push(w - 1, j); }
          while (stack.length) {
            p = stack.pop(); var o = p * 4, dd = dist(d, o, bg);
            if (dd <= T1) { d[o + 3] = 0; var xx = p % w, yy = (p - xx) / w; push(xx + 1, yy); push(xx - 1, yy); push(xx, yy + 1); push(xx, yy - 1); }
            else if (dd < T2) {
              var a = (dd - T1) / (T2 - T1), al = Math.round(a * 255);
              if (al < d[o + 3]) {
                d[o + 3] = al;
                for (var k = 0; k < 3; k++) { var v = (d[o + k] - bg[k] * (1 - a)) / a; d[o + k] = v < 0 ? 0 : v > 255 ? 255 : v; }
              }
            }
          }
          x.putImageData(im, 0, 0);
        }
      }
      /* trim transparent borders */
      var id2 = x.getImageData(0, 0, w, h).data, minX = w, minY = h, maxX = 0, maxY = 0;
      for (var yy2 = 0; yy2 < h; yy2++) for (var xx2 = 0; xx2 < w; xx2++) {
        if (id2[(yy2 * w + xx2) * 4 + 3] > 10) { if (xx2 < minX) minX = xx2; if (xx2 > maxX) maxX = xx2; if (yy2 < minY) minY = yy2; if (yy2 > maxY) maxY = yy2; }
      }
      var out = c;
      if (maxX > minX && maxY > minY) {
        var cw = maxX - minX + 1, ch = maxY - minY + 1;
        out = document.createElement('canvas'); out.width = cw; out.height = ch;
        out.getContext('2d').drawImage(c, minX, minY, cw, ch, 0, 0, cw, ch);
      }
      img.removeAttribute('srcset');
      img.src = out.toDataURL('image/png');
      img.classList.add('is-cut');
    } catch (e) { /* tainted canvas etc. -> CSS fallback stays */ }
  }
  function run() {
    document.querySelectorAll('img[data-autobg]:not([data-cut])').forEach(function (img) {
      if (img.complete && img.naturalWidth) cut(img); else img.addEventListener('load', function () { cut(img); }, { once: true });
    });
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(run, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', later);
  new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
})();
